import columns from '../../../../../react-table/helpers/columns';

export default (data, assetType) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: 'History',
      columns: [
        new TextColumn('Outbound Operator', 'operatorFrom'),
        new TextColumn('Outbound IMPC', 'impcFrom'),
        new TextColumn('Inbound Operator', 'operatorTo'),
        new TextColumn('Inbound IMPC', 'impcTo'),
        new TextColumn('Priority', 'priority'),
        new TextColumn('Transfer Operators', 'transferOperators').withShow(assetType === 'pallet'),
        new TextColumn('Transfer IMPCs', 'transferLocations').withShow(assetType === 'pallet'),
        new DateTimeColumn('Route Start Date', 'routeStartDate'),
        new DateTimeColumn('Route End Date', 'routeEndDate'),
        new TextColumn('User', 'user'),
        new NonZeroNumberColumn('ID', 'id'),
        new TextColumn('Comments', 'comments'),
        new DateTimeColumn('Last Updated', 'when'),
        new DateTimeColumn('Exceptional LC Start date', 'exceptionalLCStartDate').withShow(assetType === 'pallet'),
        new DateTimeColumn('Exceptional LC Stop date', 'exceptionalLCEndDate').withShow(assetType === 'pallet'),
      ],
    },
  ];
};
